import React from 'react';
import useAppContext from 'flow/hooks/useAppContext';
import { useAppSelector } from 'flow/hooks/useRedux';
import { selectActiveMeetingMembers } from 'flow/selectors/meeting-selectors';
import { GRID_LIMIT } from 'flow/utils/meeting-constants';

const MeetingMoreMembersIndicator = () => {
    const { i18next } = useAppContext();

    const numberOfMembers = useAppSelector(
        (state) => selectActiveMeetingMembers(state)?.size || 0,
    );

    const numberOfMembersOutsideGrid = numberOfMembers - GRID_LIMIT - 1; // -1 exclude sender
    const gridLimitIncludingSender = GRID_LIMIT + 1;
    const moreMembersCount =
        '\n' +
        numberOfMembersOutsideGrid +
        '\n' +
        (numberOfMembersOutsideGrid > 1
            ? i18next.t('videoconference.gridlimit_more_participants')
            : i18next.t('videoconference.gridlimit_more_participant'));

    return (
        <>
            {numberOfMembers > gridLimitIncludingSender ? (
                <div className="flex rounded-xl px-3 py-2 text-center leading-normal whitespace-nowrap">
                    {moreMembersCount}
                </div>
            ) : null}
        </>
    );
};

export default MeetingMoreMembersIndicator;
